import type { GalleryPhotoType, IInstallationPoint } from '../constants/sensorGalleryType';

export const getInstallationPointIds = (
  installationPoints: IInstallationPoint[] | null,
  imageType: GalleryPhotoType,
  isAllChecked: boolean,
) => {
  if (!installationPoints) return;
  if (
    imageType === 'primaryImage' ||
    imageType === 'equipmentImage' ||
    (imageType === 'nameplatePhoto' && isAllChecked)
  )
    return [];

  return installationPoints?.map((point) => point.id);
};
